import React, { ReactNode } from "react";
import styled from "@emotion/styled";

const KNOB_SIZE = 20;
const KNOB_INSET = 3;
const TRACK_WIDTH = 42;
const TRACK_HEIGHT = 26;

const Track = styled.button<{ checked: boolean }>(({ checked }) => ({
  position: "relative",
  display: "block",
  flexShrink: 0,
  width: TRACK_WIDTH,
  height: TRACK_HEIGHT,
  padding: 0,
  margin: 0,
  border: "1px solid currentColor",
  borderRadius: TRACK_HEIGHT / 2,
  color: "var(--textTitle)",
  background: checked ? "#333" : "#fafafa",
  cursor: "pointer",
  transition: "background-color 150ms cubic-bezier(0.4, 0, 0.2, 1)",
}));

const Knob = styled.span<{ checked: boolean }>(({ checked }) => ({
  position: "absolute",
  // Offsets are from inside the 1px track border
  top: KNOB_INSET - 1,
  left: KNOB_INSET - 1,
  display: "flex",
  transform: checked
    ? `translateX(${TRACK_WIDTH - KNOB_SIZE - KNOB_INSET * 2}px)`
    : "none",
  transition: "transform 150ms cubic-bezier(0.4, 0, 0.2, 1)",
}));

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  icon: ReactNode;
  checkedIcon: ReactNode;
};

const Switch = ({ checked, onChange, label, icon, checkedIcon }: Props) => (
  <Track
    type="button"
    role="switch"
    aria-checked={checked}
    checked={checked}
    onClick={() => onChange(!checked)}
  >
    <span className="visually-hidden">{label}</span>
    <Knob checked={checked} aria-hidden="true">
      {checked ? checkedIcon : icon}
    </Knob>
  </Track>
);

export default Switch;
